var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{attrs:{"role":"main"}},[_c('div',{staticClass:"album "},[_c('div',{staticClass:"carousel-item active"},[_c('img',{staticStyle:{"width":"100%","height":"800px"},attrs:{"src":_vm.introduction}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }